package no.vareflow.app.domain

import kotlin.js.Date

// Browser versions of the locale-dependent formatting (Intl API, Norwegian Bokmål).

private fun two(value: Int): String = value.toString().padStart(2, '0')

actual fun compareNorwegian(a: String, b: String): Int {
    val options: dynamic = js("({ sensitivity: 'base' })")
    return (a.asDynamic().localeCompare(b, "nb-NO", options) as Number).toInt()
}

private fun formatNumber(value: Double, minFraction: Int, maxFraction: Int): String {
    val options: dynamic = js("({ useGrouping: false })")
    options.minimumFractionDigits = minFraction
    options.maximumFractionDigits = maxFraction
    return value.asDynamic().toLocaleString("nb-NO", options) as String
}

actual fun formatPrice(value: Double): String =
    if (value % 1.0 == 0.0) value.toInt().toString() else formatNumber(value, 2, 2)

actual fun formatDateTime(time: Long): String {
    val d = Date(time.toDouble())
    return "${two(d.getDate())}.${two(d.getMonth() + 1)}.${d.getFullYear()} ${two(d.getHours())}:${two(d.getMinutes())}"
}

actual fun formatTime(time: Long): String {
    val d = Date(time.toDouble())
    return "${two(d.getHours())}:${two(d.getMinutes())}"
}

actual fun formatQuantity(value: Double): String = formatNumber(value, 0, 3)

actual fun currentYearMonth(): String {
    val d = Date()
    return YearMonthValue(d.getFullYear(), d.getMonth() + 1).toString()
}
